export default "__VITE_ASSET__CAMYpGY4__"